import React from 'react'
import moment from 'moment'
import cn from 'classnames'

import FeedReactions from '../../FeedReactions'
import { getUserFullName } from 'helpers/getUserUIData'
import { ACTION_NAMES } from 'app/constants/feed'
import './styles.scss'
export const bc = 'feed-recent-badge-achievement-item'

const FeedRecentBadgeAchievementItem = ({
  t,
  identity,
  user,
  timestamp,
  event: { id, name },
  setReaction,
  reactions,
  updateReaction,
  showReactions,
  index,
  handleSetFeedEventLikeOld,
  isNewEvent,
  sprint: { badge, badgeTitle },
}) => {
  const identityData = identity.toJS()
  const userReaction = reactions && reactions.find(item => item.user.id === identityData.id)
  const fullName = getUserFullName(user.firstName, user.lastName, user.email)

  return (
    <div className={cn(bc, { [`${bc}__new`]: isNewEvent })} onAnimationEnd={() => handleSetFeedEventLikeOld(index)}>
      <div className={`${bc}__wrapper`}>
        <div className={`${bc}__image`}>
          <img className={`${bc}__image-holder`} src={badge} alt={badgeTitle} />
        </div>
        <div className={`${bc}__user`}>
          <div className={`${bc}__title`}>
            {t('Congratulate')} {fullName}
          </div>
          <div className={`${bc}__message`}>{`${t(`common:${ACTION_NAMES[name].title}`)} '${badgeTitle}'`}</div>
        </div>
        <div className={`${bc}__date`}>{moment(timestamp).fromNow()}</div>
      </div>
      {showReactions && (
        <div className={`${bc}__reactions`}>
          <FeedReactions
            reactions={reactions}
            hasReacted={Boolean(userReaction)}
            setReaction={emoji => {
              userReaction ? updateReaction(userReaction, emoji) : setReaction(emoji, id, identityData)
            }}
            likeActionEnabled={user.id !== identityData.id}
          />
        </div>
      )}
    </div>
  )
}

export default FeedRecentBadgeAchievementItem
